import { Pages } from './routes';

export let App = () => {
  return <Pages />;
};
